import { catalogApiFetch } from "../admin/jscontrol/apiClient";
import { getImageSrc, parseApiList } from "./productStorefront";

export const ADD_BANNER_SLOT_COUNT = 5;

export const isAddBannerActive = (b) => {
  const active = b?.IsActive ?? b?.isActive;
  if (active === undefined || active === null) return true;
  return active === true || active === 1 || String(active).toLowerCase() === "true";
};

export const normalizeAddBannerRow = (b) => ({
  AddBannerId: b?.AddBannerId ?? b?.addBannerId,
  Title: b?.Title ?? b?.title ?? "Banner",
  ImageUrl: b?.ImageUrl ?? b?.imageUrl ?? b?.ImageURL ?? "",
  RedirectUrl: b?.RedirectUrl ?? b?.redirectUrl ?? "",
  DisplayOrder: Number(b?.DisplayOrder ?? b?.displayOrder ?? 0),
  IsActive: b?.IsActive ?? b?.isActive,
});

export const mapAddBannerItem = (b) => {
  const row = normalizeAddBannerRow(b);
  return {
    id: row.AddBannerId,
    title: row.Title,
    imageSrc: getImageSrc(row.ImageUrl),
    redirectUrl: String(row.RedirectUrl || "").trim(),
    displayOrder: row.DisplayOrder,
  };
};

export const parseAddBannerList = (body) => {
  if (!body) return [];
  if (Array.isArray(body)) return body;
  if (Array.isArray(body.data)) return body.data;
  if (body?.data && Array.isArray(body.data.data)) return body.data.data;
  return parseApiList(body);
};

export const mapAddBannersByOrder = (items) => {
  const sorted = items
    .map(normalizeAddBannerRow)
    .filter((b) => isAddBannerActive(b) && b.ImageUrl)
    .sort((a, b) => {
      const o = a.DisplayOrder - b.DisplayOrder;
      if (o !== 0) return o;
      return (a.AddBannerId ?? 0) - (b.AddBannerId ?? 0);
    });

  const map = {};

  sorted.forEach((row) => {
    let slot = row.DisplayOrder;
    if (slot < 1 || slot > ADD_BANNER_SLOT_COUNT || map[slot]) {
      slot = null;
      for (let s = 1; s <= ADD_BANNER_SLOT_COUNT; s += 1) {
        if (!map[s]) {
          slot = s;
          break;
        }
      }
    }
    if (slot) {
      map[slot] = mapAddBannerItem({ ...row, DisplayOrder: slot });
    }
  });

  return map;
};

export const getActiveBannersList = (bannersByOrder = {}) =>
  Object.keys(bannersByOrder)
    .map(Number)
    .sort((a, b) => a - b)
    .map((slot) => bannersByOrder[slot])
    .filter((b) => b?.imageSrc);

export async function fetchActiveAddBannersByOrder() {
  const params = new URLSearchParams({
    pageIndex: "1",
    pageSize: "100",
    search: "",
    sortColumn: "DisplayOrder",
    sortBy: "ASC",
  });

  try {
    const { data } = await catalogApiFetch(`/AddBanner/GetAll?${params}`);
    return mapAddBannersByOrder(parseAddBannerList(data));
  } catch {
    return {};
  }
}
